declare global {
  interface Window {
    env: Record<string, string>;
  }
}

export const getEnv = (key: string) => {
  const windowEnvs = window.env || {};
  return key in windowEnvs ? windowEnvs[key] : import.meta.env[key];
};
